import type { PlayerColor } from "@nextgammon/shared";

export enum GamePlayAnimationType {
  Pregame = 1 << 0,
  State = 1 << 1,
  Checker = 1 << 2,
  Dice = 1 << 3
}

export interface CheckerMovement {
  checkerId: string;
  fromPoint: number;
  toPoint: number;
  fromPosition: { x: number; y: number };
  toPosition: { x: number; y: number };
  playerColor: PlayerColor;
  fromIsBar: boolean;
  toIsBar: boolean;
  isReverse: boolean;
}

export interface BoardDimensions {
  pointAreas: { [pointIndex: number]: [number, number, number, number] };
  barAreas: { [color: string]: [number, number, number, number] };
  bearOffAreas: { [color: string]: [number, number, number, number] };
  boardScale: number;
  unscaledCheckerHeight: number;
  // Indicates that the local presentation of the board is flipped
  boardIsFlipped: boolean;
}

export const ANIMATION_CONFIG = {
  MIN_DURATION: 200,
  MAX_DURATION: 600,
  BASE_SPEED: 400,
  UNDO_SPEED_MULTIPLIER: 0.7,
  REVERSE_DURATION_MULTIPLIER: 0.7,
  OPPONENT_DURATION_MULTIPLIER: 3.0
};
